// extracted by mini-css-extract-plugin
export default {"zoomModal":"B4-z","image":"C4-z","button":"D4-z","isOverlayShown":"E4-z"};